import React, {useEffect, useState} from 'react';
import {executeQueryUtil} from "../../utils/gqlUtil";
import {getDashBoardsQuery} from "../../gql/dashBoardGql";
import useAuth from "../../hooks/useAuth";
import localStrings from "../../localStrings";
import PageWithTitle from "../../components/pages/pageWithTitle";
import {Box, Button, Stack} from "@mui/material";
import {customBoardsRoute, dashboardBaseRoute, dashboardRoutes} from "../../routes/dashboard";
import {useNavigate} from "react-router";

function DashboardNavForMobile() {
    const navigate = useNavigate();
    const {
        userInDb,

    } = useAuth();

    const [dashBoards, setDashBoards] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!userInDb) {
            return;
        }
        async function setItemSourceAsync() {
            let result = await executeQueryUtil(getDashBoardsQuery(userInDb.id));
            setDashBoards(result?.data?.getDashBoards || []);
        }
        setItemSourceAsync();
    }, [userInDb]);

    return (
        <PageWithTitle title={localStrings.myDashboards}>
            <Box sx={{ px: 2, mt: 3}}>

                <Button
                    sx={{ mb: 2 }}
                    variant="outlined"
                    onClick={() => navigate(`/${dashboardBaseRoute}`)}
                    fullWidth
                >
                    {localStrings.mainDashboard}
                </Button>

                {dashBoards && dashBoards?.length > 0 && (
                    <Stack spacing={2} mt={2}>

                        {dashBoards.map((dashboard) => (
                            <Button
                                key={dashboard.id}
                                variant="contained"
                                onClick={() => navigate(`/${dashboardBaseRoute}/customBoards/${dashboard.id}`)}
                                fullWidth
                            >
                                {dashboard.name}
                            </Button>
                        ))}
                    </Stack>
                )}

                <Button
                    sx={{ mt: 3 }}
                    variant="outlined"
                    onClick={() => navigate(`/${dashboardBaseRoute}/${customBoardsRoute}`)}
                    fullWidth
                >
                    {localStrings.manageMyBoards}
                </Button>
            </Box>
        </PageWithTitle>
    )
}

export default DashboardNavForMobile